import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  formatTimeFromSeconds,
  convertSecondsFromStringTime,
} from "@/services/functions";
import { computed } from "vue";
import DeliveryPlanType from "@/types/DeliveryPlan"


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryRow',
  props: {
    detailDataRef: {},
    boundTimeByHours: {},
    boundTimeByDays: {}
  },
  setup(__props: any) {

const props = __props;

const monthlyTrips = computed(() => {
  const trips = [];
  const cp = JSON.parse(JSON.stringify(props.detailDataRef));
  cp.forEach((detailData) => {
    (detailData.trips ?? []).forEach((trip) => {
      trips.push(trip);
    });
  });
  return trips;
});

const summary = (key) => {
  let sum = 0;
  monthlyTrips.value.forEach((trip) => {
    sum += trip[key];
  });
  return sum;
};

const workingDays = computed(() => {
  return props.detailDataRef.filter((detailData) => {
    return detailData.trips.length
  }).length
});

const average = computed(() => {
  const totalByTrip = summary("total_by_trip") - summary("leaving_diff_time")
  return formatTimeFromSeconds(totalByTrip / workingDays.value);
});

const boundTimeColor = () => {
  if (!average.value || !props.boundTimeByHours) return "black";
  if (props.boundTimeByHours == "0") return "black";

  const averageSeconds = convertSecondsFromStringTime(average.value);
  const boundTimeByHoursSeconds = convertSecondsFromStringTime(
    props.boundTimeByHours
  );

  return averageSeconds > boundTimeByHoursSeconds ? "red" : "black";
};

const boundDayColor = () => {
  if (!workingDays.value || !props.boundTimeByDays) return "black";
  if (props.boundTimeByDays == "0") return "black";

  return Number(workingDays.value) > Number(props.boundTimeByDays)
    ? "red"
    : "black";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      style: _normalizeStyle('color:' + boundTimeColor())
    }, _toDisplayString(average.value) + " / " + _toDisplayString(props.boundTimeByHours), 5),
    _createElementVNode("td", {
      style: _normalizeStyle('color:' + boundDayColor())
    }, _toDisplayString(workingDays.value) + " / " + _toDisplayString(props.boundTimeByDays), 5)
  ]))
}
}

})